import DownloadIcon from '@mui/icons-material/Download';
import { IconButton, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';

export interface EditCardDownloadButtonProps {
  /** Signed URL for the rendered media file. */
  href: string;
}

/**
 * Icon link to download the rendered edit video.
 */
export function EditCardDownloadButton({ href }: EditCardDownloadButtonProps) {
  const { $t } = useIntl();
  const downloadLabel = $t({
    id: 'common.download',
    defaultMessage: 'Descargar',
  });

  return (
    <Tooltip title={downloadLabel}>
      <IconButton component="a" href={href} size="small" rel="noopener noreferrer">
        <DownloadIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
